
  // jQuery DOM-ready wrapper; remove if you don't use jQuery
  jQuery(function ($) {
    const LeaseDisclosure = (() => {
      const TERM_MONTHS = 18;
      const BIWEEKLY_COUNT = 36;
      const SEMIMONTHLY_COUNT = 36;

      const GROUPS = {
        threeMonthMin: new Set(["AL", "FL", "GA", "IL", "TN"]),
        twoMonthMin: new Set(["CA", "OH", "NY", "PA"]),
        onePaymentMin: new Set(["WV", "SC"]),
        northCarolina: new Set(["NC"]),
      };

      const fmt = (n) =>
        new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);

      const toMoney = (n) => Number((Math.round(n * 100) / 100).toFixed(2));

      function classifyState(state) {
        if (GROUPS.northCarolina.has(state)) return "NC";
        if (GROUPS.threeMonthMin.has(state)) return "3M";
        if (GROUPS.twoMonthMin.has(state)) return "2M";
        if (GROUPS.onePaymentMin.has(state)) return "1P";
        return "5M";
      }

      function buildSentence({ minObligation, monthly, biHalf, total, balloon = null }) {
        const base =
          `Minimal lease obligation is ${minObligation}. No security deposit is required. ` +
          `Total Lease Purchase term and cost is ${TERM_MONTHS} monthly payments, ` +
          `${BIWEEKLY_COUNT} biweekly payments, or ${SEMIMONTHLY_COUNT} semi-monthly payments ` +
          `at ${fmt(monthly)} per month (${fmt(biHalf)} biweekly/semi-monthly)`;

        const balloonPart = balloon ? `, plus a balloon payment of ${fmt(balloon)}` : "";
        const totalPart = ` for a total lease purchase cost of ${fmt(total)}.`;
        return base + balloonPart + totalPart;
      }

      function getMinObligationLabel(code) {
        switch (code) {
          case "3M": return "3 months";
          case "2M": return "2 months";
          case "1P": return "1 payment";
          case "5M": return "5 months";
          default:   return "3 months";
        }
      }

      function computeTotals(monthly, stateCode) {
        const monthlyRounded = toMoney(monthly);
        const biHalf = toMoney(monthlyRounded / 2);
        const baseTotal = toMoney(monthlyRounded * TERM_MONTHS);
        if (stateCode === "NC") {
          const balloon = monthlyRounded;
          return { monthly: monthlyRounded, biHalf, total: toMoney(baseTotal + balloon), balloon };
        }
        return { monthly: monthlyRounded, biHalf, total: baseTotal, balloon: null };
      }

      function normalizeState(state) {
        return String(state || "").trim().toUpperCase();
      }

      function validateRate(monthlyRate) {
        if (typeof monthlyRate !== "number" || !isFinite(monthlyRate) || monthlyRate <= 0) {
          throw new Error("monthlyRate must be a positive number.");
        }
      }

      function getDisclosureHTML(monthlyRate, state) {
        validateRate(monthlyRate);
        const st = normalizeState(state);
        const bucket = classifyState(st);
        const { monthly, biHalf, total, balloon } = computeTotals(
          monthlyRate,
          bucket === "NC" ? "NC" : st
        );

        const sentence = buildSentence({
          minObligation: getMinObligationLabel(bucket),
          monthly,
          biHalf,
          total,
          balloon
        });

        const prefix = (() => {
          switch (bucket) {
            case "3M": return "AL/FL/GA/IL/TN:";
            case "2M": return "CA/OH/NY/PA:";
            case "NC": return "NC:";
            case "1P": return "WV, SC:";
            case "5M": return "All Other States:";
            default:   return "";
          }
        })();

        return `<p><strong>${prefix}</strong> ${sentence}</p>`;
      }

      function getAllDisclosuresHTML(monthlyRate) {
        validateRate(monthlyRate);
        const parts = [
          getDisclosureHTML(monthlyRate, "AL"),
          getDisclosureHTML(monthlyRate, "CA"),
          getDisclosureHTML(monthlyRate, "NC"),
          getDisclosureHTML(monthlyRate, "WV"),
          getDisclosureHTML(monthlyRate, "XX"),
        ];
        return parts.join("\n");
      }

      return { getDisclosureHTML, getAllDisclosuresHTML };
    })();

    // Make available globally if you want:
    window.LeaseDisclosure = LeaseDisclosure;

    // Render when DOM is ready
    const $container = $('.gp-custom-code.monthly-terms');
    const staticHTML = '<p>Ownership is optional. This is a rent to own/lease to own/lease purchase transaction. You do not own the equipment until all payments are made OR you exercise your early purhcase option.</p><p>NY and CA have a 3 month same as cash buyout option. All other states have a 90 day same as cash buyout. If you buyout during your same as cash period, the total you will pay (rental plus buyout price) will add up to equal the cash price (plus tax and applicable fees) You can exercise your right to buyout your agreement at any time. A portion of each payment you make goes toward reducing your buyout price. Please contact us, refer to your lease agreement, or view your account in the account management portal to see your buyout price.</p>'
    if ($container.length) {
      setTimeout(function() {
    var monthlyPrice =
      Number($('#product-price-product').data('monthly-price')) || 275;
    $container.html(staticHTML + LeaseDisclosure.getAllDisclosuresHTML(monthlyPrice));
      },1500)
    }
// Listen for clicks on both inputs and labels (delegated, works dynamically)
$(document).on('click', '.swatches__form--input, .custom-swatches__form--input, .swatches__form--label, .custom-swatches__form--label', function () {

  setTimeout(function () {
    const $el = $('#product-price-product');

    // Always pull the freshest value (no .data() caching)
    const newMonthly =
      Number($el.attr('data-monthly-price')) ||
      Number(String($el.text() || '').replace(/[^0-9.]/g, '')) ||
      275;


    $container.html(staticHTML + LeaseDisclosure.getAllDisclosuresHTML(newMonthly));
  }, 200); // small delay to wait for DOM update
});


  });